import { z } from "zod";

export const GraphQLError = z.object({
  message: z.string(),
});

export type GraphQLError = z.infer<typeof GraphQLError>;
